import React, { memo, useContext, useMemo, useRef, useState } from 'react';
import { usePriceTriggerChange } from '../helpers';
import { useAppDispatch, useAppSelector } from '../../../redux/app';
import { TradeContext } from '../context/TradeContextProvider';
import { setPayload } from '../../../redux/reducer/payload';
import { makeBidAskSelector } from '../../../redux/selector';
import cn from '../../../utilities/cn';
import { DirectionIcons } from '@vt/vt-ui';

const InputTriggerPrice = memo(({ validate, className }) => {
  const priceRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  const getBidAsk = useMemo(makeBidAskSelector, []);

  const ask = useAppSelector((state) => getBidAsk(state, 'ask'));
  const bid = useAppSelector((state) => getBidAsk(state, 'bid'));

  const data = useAppSelector((state) => state.payload?.payload);

  const { instrumentInfo } = useContext(TradeContext);
  const dispatch = useAppDispatch();

  const handlePrice = (type) => {
    const price = usePriceTriggerChange({
      type: type,
      price_trigger: data.price_trigger,
      ask,
      digits: instrumentInfo?.digit
    });
    dispatch(
      setPayload({
        ...data,
        price_trigger: price
      })
    );
  };

  const validatePrice = (key, pOder = 0) => {
    // const dfp = pOder - instrumentInfo?.stops_level * Math.pow(10, -instrumentInfo?.digit);
    let price_trigger = 0;
    switch (key) {
      case 6:
        price_trigger = ask ?? 0;
        break;
      case 7:
        price_trigger = bid ?? 0;
        break;
      default:
        price_trigger = 0;
        break;
    }
    return dispatch(
      setPayload({
        ...data,
        price_trigger
      })
    );
  };

  return (
    <div className={cn("relative border hover:border-[#0FEF9E] rounded-lg mx-3 mt-2", isFocused ? "border-[#0FEF9E]" : "border-[#4B4B4B]")}>
      <input
        onChange={({ target: { value } }) => {
          if (value !== '') {
            if (value.startsWith('-')) {
              priceRef.current.value = data.price_trigger;
            } else {
              dispatch(
                setPayload({
                  ...data,
                  price_trigger: +value
                })
              );
            }
          } else {
            dispatch(
              setPayload({
                ...data,
                price_trigger: 0
              })
            );
          }
        }}
        type="number"
        ref={priceRef}
        value={data.price_trigger <= 0 ? '' : data.price_trigger}
        placeholder="No Set"
        className="input-left-lotsize p-[10px] text-[#e5e5e5] !w-[calc(100%-24px)]"
        style={{ caretColor: isFocused ? '#0FEF9E' : 'auto' }}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onMouseDown={() => {
          if (data.price_trigger === 0 || data.price_trigger === '') {
            validatePrice(validate);
          }
        }}
      />
      <div className="absolute right-0 top-0 bottom-0 flex w-6 flex-col rounded-r-lg border-l border-[#4b4b4b] hover:border-[#0FEF9E]">
        <button
          type="button"
          className={cn(
            'vt-flex group hover:bg-[#0FEF9E] flex-1 items-center justify-center rounded-tr-lg border-b border-[#4b4b4b] transition-colors',
          )}
          onClick={() => handlePrice('inc')}
        >
          <DirectionIcons.Up className="h-4 w-4 stroke-neutral-400 fill-neutral-400 group-hover:stroke-[#151515] group-hover:fill-[#151515] transition-colors" />
        </button>
        <button
          type="button"
          className={cn(
            'vt-flex group flex-1 hover:bg-[#0FEF9E] items-center justify-center rounded-br-lg transition-colors',
          )}
          onClick={() => handlePrice('dec')}
        >
          <DirectionIcons.Down className="h-4 w-4 stroke-neutral-400 fill-neutral-400 group-hover:stroke-[#151515] group-hover:fill-[#151515] transition-colors" />
        </button>
      </div>
    </div>
  )
});

InputTriggerPrice.displayName = 'InputTriggerPrice';

export default InputTriggerPrice;
